import { makeStyles } from '@material-ui/core/styles';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.shape.componentSpacing,
  },
  content: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(1),
      ...theme.mixins.marginLeft(theme.spacing(5)),
    },
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiIconButton-root': {
      padding: 0,
      ...theme.mixins.marginLeft(theme.spacing(1.5)),
      [theme.breakpoints.up('lg')]: {
        ...theme.mixins.marginLeft(theme.spacing(3)),
      },
      '& svg': {
        color: theme.palette.text.primary,
        height: theme.spacing(3.5),
        width: theme.spacing(3.5),
      },
    },
  },
  table: {
    '& .header': {
      backgroundColor: theme.mixins.Grey(60),

      '& th': {
        padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
        '&:first-child': {
          borderRadius: `${borderRadius.b3Rem} 0 0 0`,
        },
        '&:last-child': {
          borderRadius: `0 ${borderRadius.b3Rem} 0 0`,
        },
        [theme.breakpoints.up('lg')]: {
          padding: `${theme.spacing(3)} ${theme.spacing(5)}`,
        },
      },
    },
  },
  tableBody: {
    '& .MuiTableCell-root': {
      borderBottom: 0,
    },
    '& td, & td:last-child': {
      padding: `${theme.spacing(2.5)} ${theme.spacing(3)}`,
      [theme.breakpoints.up('lg')]: {
        paddingLeft: `${theme.spacing(5)}`,
        paddingRight: `${theme.spacing(5)}`,
      },
    },
    '& tr:first-child td': {
      paddingTop: theme.spacing(2.5),
      [theme.breakpoints.up('lg')]: {
        paddingTop: theme.spacing(5),
      },
    },
    '& tr:last-child td': {
      paddingBottom: theme.spacing(2.5),
      [theme.breakpoints.up('lg')]: {
        paddingBottom: theme.spacing(5),
      },
    },
  },
  iconButton: {
    cursor: 'pointer',
    display: 'flex',
    ...theme.mixins.marginLeft(theme.spacing(1.5)),
    [theme.breakpoints.up('lg')]: {
      ...theme.mixins.marginLeft(theme.spacing(3)),
    },
    '& svg': {
      color: theme.palette.text.primary,
      height: theme.spacing(3.5),
      width: theme.spacing(3.5),
    },
  },
  gridContainer: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
}));

export default useStyles;
